angular.module('leanlaw').factory('depositListsDefinition', ['singleRequest', function (singleRequest) {
  const load = ({
    query,
    filter,
    me
  }) => {
    query.transactions = true;
    query.clients = true;
    query.id = filter.trustAccount.id;
    query.startDate = filter.dateRange.range.startDate;
    query.endDate = filter.dateRange.range.endDate;
    return singleRequest.apiCall('list-accounting-accounts').getAccountingAccount(query).then(result => {
      if (!result) return undefined;
      const operatingAccount = filter.trustAccount.id === me.company.settings?.trust?.operating.id;
      const transactions = result.transactions.filter(transaction => transaction.type === (operatingAccount ? "Payment" : "Deposit"));
      return {
        rows: transactions.map(t => ({
          values: {
            date: {
              value: t.date
            },
            client: {
              value: t.client && t.client.label
            },
            matter: {
              value: t.matter && t.matter.label
            },
            memo: {
              value: t.description
            },
            amount: {
              value: t.amount
            }
          }
        }))
      };
    });
  };
  const structure = ({
    me
  }) => {
    return {
      sort: 'date',
      subrow: {
        label: undefined
      },
      totals: {
        rows: true,
        columns: false,
        totalLabelCells: 2
      },
      panel: {
        show: me.company.settings.trust.deposits,
        label: "Your firm is configured to use an Undeposited Funds account. Transactions in the Undeposited Funds account will not appear in the Deposit Report."
      },
      showFilters: {
        dateRange: true,
        trustAccount: true
      },
      columns: [{
        id: 'date',
        label: 'Date',
        filter: 'dateStandard'
      }, {
        id: 'client',
        label: 'Client'
      }, {
        id: 'matter',
        label: 'Matter',
        toolTip: 'Entries with client-accounting enabled will have a blank Matter field'
      }, {
        id: 'memo',
        label: 'Memo'
      }, {
        id: 'amount',
        label: 'Amount',
        number: true,
        filter: 'amount'
      }]
    };
  };
  const cancel = params => {
    singleRequest.cancel('list-accounting-accounts');
  };
  return {
    structure,
    load,
    cancel
  };
}]);